import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withModifiers as _withModifiers, withKeys as _withKeys, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-4fbaf06f"), n = n(), _popScopeId(), n);

const _hoisted_1 = ["element-loading-spinner"];
const _hoisted_2 = {
  class: "out_box"
};

const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  style: {
    "font-size": "1rem",
    "cursor": "pointer"
  }
}, "返回", -1));

const _hoisted_4 = {
  class: "title_box"
};

const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "catalog"
}, "目录", -1));

const _hoisted_6 = {
  style: {
    "display": "flex",
    "flex-direction": "row",
    "align-items": "center",
    "justify-content": "space-around"
  }
};
const _hoisted_7 = {
  style: {
    "overflow": "auto"
  },
  ref: "treeBox"
};
const _hoisted_8 = ["onDblclick"];
const _hoisted_9 = {
  style: {
    "display": "flex",
    "flex-direction": "row",
    "align-items": "center"
  }
};
const _hoisted_10 = {
  key: 0,
  style: {
    "user-select": "none",
    "font-size": ".8rem",
    "font-weight": "bold",
    "max-width": "15rem",
    "overflow": "hidden",
    "text-overflow": "ellipsis"
  }
};
const _hoisted_11 = ["onUpdate:modelValue", "onBlur", "onKeyup"];
const _hoisted_12 = {
  key: 0,
  style: {
    "color": "red",
    "margin-left": ".2rem",
    "font-size": ".8rem",
    "font-weight": "bold"
  }
};
const _hoisted_13 = {
  style: {
    "color": "red",
    "font-weight": "bold",
    "user-select": "none",
    "font-size": ".8rem"
  }
};
const _hoisted_14 = {
  class: "out_box"
};
const _hoisted_15 = {
  style: {
    "display": "flex",
    "width": "100%",
    "padding": "0 1rem 0 0",
    "align-items": "center"
  }
};
const _hoisted_16 = {
  style: {
    "font-weight": "bold",
    "user-select": "none"
  }
};
const _hoisted_17 = {
  style: {
    "user-select": "none",
    "max-width": "15rem",
    "overflow": "hidden",
    "text-overflow": "ellipsis"
  }
};
const _hoisted_18 = {
  class: "problem_box"
};
const _hoisted_19 = {
  class: "problem_title"
};

const _hoisted_20 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "catalog"
}, "问题", -1));

const _hoisted_21 = {
  key: 0,
  class: "content_box"
};
const _hoisted_22 = {
  class: "question_box",
  ref: "scrollRef"
};
const _hoisted_23 = {
  class: "bottom_box"
};
const _hoisted_24 = {
  class: "btn_box"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_icon = _resolveComponent("van-icon");

  const _component_el_tooltip = _resolveComponent("el-tooltip");

  const _component_el_tree = _resolveComponent("el-tree");

  const _component_ProductionFilter2 = _resolveComponent("ProductionFilter2");

  const _component_el_form_item = _resolveComponent("el-form-item");

  const _component_el_input = _resolveComponent("el-input");

  const _component_el_form = _resolveComponent("el-form");

  const _directive_focus = _resolveDirective("focus");

  const _directive_loading = _resolveDirective("loading");

  return _withDirectives((_openBlock(), _createElementBlock("div", {
    class: "main",
    "element-loading-text": "Loading...",
    "element-loading-spinner": $data.svg,
    "element-loading-svg-view-box": "-10, -10, 50, 50",
    "element-loading-background": "rgba(122, 122, 122, 0.8)"
  }, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", {
    style: {
      "display": "flex",
      "flex-direction": "row",
      "align-items": "center"
    },
    onClick: _cache[0] || (_cache[0] = $event => $options.clickReturn())
  }, [_createVNode(_component_van_icon, {
    size: "20",
    name: "arrow-left"
  }), _hoisted_3]), _createElementVNode("div", _hoisted_4, [_hoisted_5, _createElementVNode("div", _hoisted_6, [_createElementVNode("p", {
    class: "addCatalog",
    onClick: _cache[1] || (_cache[1] = (...args) => $options.clickSaveOrUpdateDirectory && $options.clickSaveOrUpdateDirectory(...args))
  }, "增加同级目录"), _createElementVNode("p", {
    class: "addCatalog",
    onClick: _cache[2] || (_cache[2] = (...args) => $options.clickSaveOrUpdateDirectoryOfChildren && $options.clickSaveOrUpdateDirectoryOfChildren(...args))
  }, "增加子目录"), _createElementVNode("p", {
    class: "deleteCatalog",
    onClick: _cache[3] || (_cache[3] = (...args) => $options.clickDeleteByDirectory && $options.clickDeleteByDirectory(...args))
  }, "删除目录")])]), _createElementVNode("div", _hoisted_7, [_createVNode(_component_el_tree, {
    ref: "treeList",
    "highlight-current": true,
    "expand-on-click-node": false,
    "node-key": "id",
    "current-node-key": $data.hightLightNode,
    data: $data.treeListData,
    props: $data.defaultProps,
    "default-expanded-keys": $data.currentNodeIds,
    onNodeClick: $options.clickColumnData
  }, {
    default: _withCtx(({
      node,
      data
    }) => [_createElementVNode("div", {
      onDblclick: $event => $options.startEditing(data),
      style: {
        "display": "flex",
        "justify-content": "space-between",
        "width": "100%",
        "padding": "0 1rem 0 0",
        "align-items": "center"
      }
    }, [_createElementVNode("div", _hoisted_9, [_createVNode(_component_el_tooltip, {
      content: data.name,
      placement: "right",
      effect: "customized",
      "show-after": 500,
      enterable: false
    }, {
      default: _withCtx(() => [!$data.editObj[data.id] ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(data.name), 1)) : _withDirectives((_openBlock(), _createElementBlock("input", {
        key: 1,
        ref: "editInput",
        "onUpdate:modelValue": $event => data.name = $event,
        onBlur: $event => $options.handleBlur($event, data),
        onKeyup: _withKeys(_withModifiers($event => $options.endEditing(data), ["prevent"]), ["enter"]),
        style: {
          "height": "1rem",
          "padding": ".5rem .2rem",
          "border-radius": ".2rem"
        }
      }, null, 40, _hoisted_11)), [[_directive_focus], [_vModelText, data.name]])]),
      _: 2
    }, 1032, ["content"]), data.id != 0 ? (_openBlock(), _createElementBlock("p", _hoisted_12, "(" + _toDisplayString(data.sopSumNum) + ")", 1)) : _createCommentVNode("", true)]), _createElementVNode("p", _hoisted_13, _toDisplayString(data.sumNum), 1)], 40, _hoisted_8)]),
    _: 1
  }, 8, ["current-node-key", "data", "props", "default-expanded-keys", "onNodeClick"])], 512)]), _createElementVNode("div", _hoisted_14, [_createVNode(_component_el_tree, {
    ref: "questionRef",
    "node-key": "id",
    data: $options.questionList,
    props: $data.questionDefaultProps,
    "highlight-current": "",
    onNodeClick: $options.clickQuestionList
  }, {
    default: _withCtx(({
      node,
      data
    }) => [_createElementVNode("div", _hoisted_15, [_createElementVNode("p", _hoisted_16, _toDisplayString(data.order_no) + ".", 1), _createVNode(_component_el_tooltip, {
      content: data.label,
      placement: "right",
      effect: "customized",
      "show-after": 500,
      enterable: false
    }, {
      default: _withCtx(() => [_createElementVNode("span", _hoisted_17, _toDisplayString(data.label), 1)]),
      _: 2
    }, 1032, ["content"])])]),
    _: 1
  }, 8, ["data", "props", "onNodeClick"])]), _createElementVNode("div", _hoisted_18, [_createElementVNode("div", _hoisted_19, [_hoisted_20, _withDirectives(_createElementVNode("input", {
    placeholder: "请输入问题序号",
    type: "number",
    "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => $data.questionOrderNo = $event),
    oninput: "value=value.replace('-','')",
    class: "number_ipt"
  }, null, 512), [[_vModelText, $data.questionOrderNo]]), _withDirectives(_createElementVNode("input", {
    class: "problem_ipt",
    "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => $data.questionTitle = $event),
    placeholder: "请输入问题标题"
  }, null, 512), [[_vModelText, $data.questionTitle]]), _createElementVNode("p", {
    onClick: _cache[6] || (_cache[6] = (...args) => $options.clickUpdateQuestion && $options.clickUpdateQuestion(...args)),
    class: "add",
    style: {
      "margin-left": "1rem"
    }
  }, "保存"), _createElementVNode("p", {
    onClick: _cache[7] || (_cache[7] = (...args) => $options.clickAddQuestion && $options.clickAddQuestion(...args)),
    class: "newAdd",
    style: {
      "margin-left": "1rem"
    }
  }, "新增"), _createElementVNode("p", {
    onClick: _cache[8] || (_cache[8] = (...args) => $options.clickDeleteQuestion && $options.clickDeleteQuestion(...args)),
    class: "delete",
    style: {
      "margin-left": "1rem"
    }
  }, "删除")]), $data.questionId ? (_openBlock(), _createElementBlock("div", _hoisted_21, [_createElementVNode("div", _hoisted_22, [_createVNode(_component_el_form, {
    model: $data.ruleForm,
    rules: $data.rules,
    ref: "ruleForm",
    "label-width": "150px",
    class: "demo-ruleForm"
  }, {
    default: _withCtx(() => [_createVNode(_component_el_form_item, {
      label: "产品",
      prop: ""
    }, {
      default: _withCtx(() => [_createVNode(_component_ProductionFilter2, {
        showAll: "",
        productionRelationArrayShow: false,
        productSelectionAndType: $data.productSelectionAndType,
        "onUpdate:productSelectionAndType": _cache[9] || (_cache[9] = $event => $data.productSelectionAndType = $event),
        baseUrl: $data.baseUrl,
        onChange: $options.changeProduction,
        style: {
          "padding": "0"
        }
      }, null, 8, ["productSelectionAndType", "baseUrl", "onChange"])]),
      _: 1
    }), _createVNode(_component_el_form_item, {
      label: "问题现象（中文）",
      prop: "problemPhenomenon",
      ref: "ruleForm"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_input, {
        type: "textarea",
        modelValue: $data.ruleForm.problemPhenomenon,
        "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => $data.ruleForm.problemPhenomenon = $event),
        placeholder: "请输入问题现象（中文）",
        rows: 3,
        resize: "none",
        maxlength: "100",
        "show-word-limit": ""
      }, null, 8, ["modelValue"])]),
      _: 1
    }, 512)]),
    _: 1
  }, 8, ["model", "rules"]), _createElementVNode("div", _hoisted_23, [_createElementVNode("div", _hoisted_24, [_createElementVNode("p", {
    onClick: _cache[11] || (_cache[11] = (...args) => $options.clickAddQuestion && $options.clickAddQuestion(...args)),
    class: "newAdd"
  }, "新增")])])], 512)])) : _createCommentVNode("", true)])], 8, _hoisted_1)), [[_directive_loading, $data.loading]]);
}